export const ADD_USER = 'addUser';
export const ADD_USERS = 'addUsers';
export const REGISTER_NEW_USER = 'registerNewUser';
export const SET_ACTIVE_USER = 'setActiveUser';
export const SET_PROFILE_PICTURE = 'setProfilePicture';
